<template>
  <MobileTopHeader />
  <router-view />
  <footer id="footer">
    <div class="contact">
      <!-- <div class="tel">
        <strong><span>상담전화 </span><a href="tel:15886450">1588-6450</a></strong>
        <p>월-금, 일요일 : 06:00 - 24:00<span>토요일 : 06:00 - 21:00</span></p>
      </div> -->
      <div class="one" style="width: 100%" @click="this.$router.push('/counsel.do?method=myCounselList')">
        <strong>1대1 상담</strong>
        <p>월-금요일 : 09:00 - 18:00<span>토,일 및 법정공휴일 휴무</span></p>
      </div>
    </div>
    <div class="btns">
      <a href="/user.do?method=loginm" class="btn_wht xsmall" v-if="!this.$store.state.isAuthenticated"><span>로그인</span></a>
      <a href="javascript:;" class="btn_wht xsmall" @click="logout()" v-else><span>로그아웃</span></a>
      <a href="/counsel.do?method=myCounselList" class="btn_wht xsmall"><span>고객센터</span></a>
    </div>
    <div class="clause">
      <ul>
        <li>
          <strong><a href="#">개인정보처리방침</a></strong>
        </li>
        <li><a href="#">이용약관</a></li>
      </ul>
    </div>
  </footer>
</template>

<script>
import MobileTopHeader from '@/components/Header/MobileTopHeader';

export default {
  components: {
    MobileTopHeader,
  },
  data: function () {
    return {
      loaded: false,
    };
  },
  mounted() {
    document.body.classList.remove('auth');
  },
  methods: {
    logout() {
      this.$store.dispatch('logout', {}).catch(({ message }) => alert(message));
    },
  },
};
</script>
<style lang="scss">
body {
  background: #fff !important;
}

[class*='section_'] {
  padding-bottom: 50px;
}

a.btn_dgray:hover {
  color: #fff;
}

.paginate_common {
  text-align: center;
  margin-top: 10px;
}
</style>
